import React from "react";
import { Grid } from "@material-ui/core";
import intl from "react-intl-universal";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
  LegendValueFormatter,
  TooltipFormatter,
} from "recharts";

import { IActiveValueData } from "utils";
import { MOVE_EVENT_EFFICIENCY_COLOR } from "MuiProvider/colors";

interface IActiveValuePanelProps {
  data: IActiveValueData;
}

const ASPECT = 2;
const CHART_WIDTH = "100%";
const BAR_SIZE = 20;

export const ActiveValuePanel = ({ data }: IActiveValuePanelProps) => {
  const legendFormatter: LegendValueFormatter = (value, entry) => {
    let label = "";
    switch (value) {
      case "totalDistance":
        label = intl.get("STATS_LABEL_ACTIVE_EVENT_DISTANCE");
        break;
      case "effectiveDistance":
        label = intl.get("STATS_LABEL_EFFECTIVE_EVENT_DISTANCE");
        break;
      case "eventCount":
        label = intl.get("STATS_LABEL_ACTIVE_EVENT_AMOUNT");
        break;
      case "effectiveEventCount":
        label = intl.get("STATS_LABEL_EFFECTIVE_ACTIVE_EVENT_AMOUNT");
        break;
    }
    return <span style={{ color: entry?.color }}>{label}</span>;
  };

  const tooltipFormatter: TooltipFormatter = (value, name) => {
    let label = "";
    switch (name) {
      case "totalDistance":
        label = intl.get("STATS_LABEL_ACTIVE_EVENT_DISTANCE");
        break;
      case "effectiveDistance":
        label = intl.get("STATS_LABEL_EFFECTIVE_EVENT_DISTANCE");
        break;
      case "eventCount":
        label = intl.get("STATS_LABEL_ACTIVE_EVENT_AMOUNT");
        break;
      case "effectiveEventCount":
        label = intl.get("STATS_LABEL_EFFECTIVE_ACTIVE_EVENT_AMOUNT");
        break;
    }
    return [value, label];
  };

  const chartData = Object.keys(data).map((key) => {
    return {
      name: data[key].name,
      totalDistance: data[key].totalDistance,
      effectiveDistance: data[key].effectiveDistance,
      eventCount: data[key].events,
      effectiveEventCount: data[key].effectiveEvents,
    };
  });

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={10} lg={8}>
        <ResponsiveContainer width={CHART_WIDTH} aspect={ASPECT}>
          <BarChart
            data={chartData}
            margin={{ top: 5, right: 5, left: 5, bottom: 5 }}
          >
            <XAxis dataKey="name" angle={-45} interval={0} />
            <YAxis scale="sqrt" />
            <Tooltip formatter={tooltipFormatter} />
            <Legend formatter={legendFormatter} />
            <Bar
              dataKey="totalDistance"
              fill={MOVE_EVENT_EFFICIENCY_COLOR.total}
              barSize={BAR_SIZE}
            />
            <Bar
              dataKey="effectiveDistance"
              fill={MOVE_EVENT_EFFICIENCY_COLOR.effectiveDistance}
              barSize={BAR_SIZE}
            />
            <Bar
              dataKey="eventCount"
              fill={MOVE_EVENT_EFFICIENCY_COLOR.event}
              barSize={BAR_SIZE}
            />
            <Bar
              dataKey="effectiveEventCount"
              fill={MOVE_EVENT_EFFICIENCY_COLOR.effectiveEvent}
              barSize={BAR_SIZE}
            />
          </BarChart>
        </ResponsiveContainer>
      </Grid>
    </Grid>
  );
};
